/* ============================================================
   Ivy Luna — motion engine
   A tiny, dependency-free system for the homepage's signature
   motion: staggered scroll reveals, the self-drawing lash-line,
   and a subtle hero parallax. Everything is gated behind
   prefers-reduced-motion (the .ivy-motion class is only added
   when motion is welcome), so reduced-motion users get the full
   content instantly with no animation and no layout shift.
   ============================================================ */
(function () {
  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Without motion we leave every element in its resting, visible state.
  if (reduce) return;

  document.documentElement.classList.add('ivy-motion');
  // Signals the theme's inline failsafe that the engine is alive.
  window.__ivyMotionReady = true;

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    // Assign a cascade index to each revealable child of a stagger group.
    document.querySelectorAll('[data-ivy-stagger]').forEach(function (group) {
      group
        .querySelectorAll('[data-ivy-reveal]')
        .forEach(function (el, i) {
          if (!el.style.getPropertyValue('--ivy-i')) {
            el.style.setProperty('--ivy-i', i);
          }
        });
    });

    // Reveal by scroll-sweep rather than IntersectionObserver: an element
    // reveals once its top crosses ~90% of the viewport height, and — crucially
    // — anything already at or above that line (on load, after scroll
    // restoration, or after a fast fling that an observer would skip) reveals
    // too. Content is therefore never left hidden above where the user has been.
    var pending = [].slice.call(document.querySelectorAll('[data-ivy-reveal]'));
    var layers = [].slice.call(document.querySelectorAll('[data-ivy-parallax]'));

    function frame() {
      var vh = window.innerHeight;
      var y = window.pageYOffset || 0;

      if (pending.length) {
        pending = pending.filter(function (el) {
          if (el.getBoundingClientRect().top < vh * 0.9) {
            el.classList.add('is-in');
            return false;
          }
          return true;
        });
      }

      layers.forEach(function (layer) {
        var speed = parseFloat(layer.getAttribute('data-ivy-parallax')) || 0.15;
        layer.style.transform = 'translate3d(0,' + y * speed + 'px,0)';
      });
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          frame();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  });
})();

/* ------------------------------------------------------------------
   PDP description accordions.

   Product descriptions are written in Admin as plain lines: a heading
   line that ends with a colon ("What's Included:") followed by its
   bullets. Rendered as-is the PDP becomes very long, so fold each
   heading + its lines into a <details>. Descriptions without such
   heading lines are left untouched.
   ------------------------------------------------------------------ */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__description').forEach(buildAccordions);
  });

  function isBlank(el) {
    return el.textContent.replace(/\s| /g, '') === '';
  }

  function isHeading(el) {
    var text = el.textContent.trim();
    return text.length > 0 && text.length <= 60 && text.slice(-1) === ':';
  }

  function buildAccordions(root) {
    if (root.dataset.ivyAccordion) return;

    var nodes = Array.prototype.slice.call(root.children);
    if (!nodes.some(isHeading)) return;

    root.dataset.ivyAccordion = 'true';

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!isHeading(node)) continue;

      var details = document.createElement('details');
      details.className = 'ivy-acc';

      var summary = document.createElement('summary');
      summary.className = 'ivy-acc__summary';
      summary.textContent = node.textContent.trim().replace(/:$/, '');
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'ivy-acc__body';
      details.appendChild(body);

      root.insertBefore(details, node);
      root.removeChild(node);

      // Everything up to the next blank line or heading belongs to this group
      for (var j = i + 1; j < nodes.length; j++) {
        var next = nodes[j];
        if (isHeading(next)) break;
        if (isBlank(next)) {
          root.removeChild(next);
          i = j;
          break;
        }
        body.appendChild(next);
        i = j;
      }
    }
  }
})();
